module.exports = __webpack_public_path__ + "img/HeresHowToWorkInComfortOfficeEE.dd1c8f1c.png";